var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkNameText)?_c('p',{staticClass:"foot-link-note"},[_vm._v("\n  "+_vm._s(_vm.name)+":\n  "),(_vm.linkUrl)?_c('span',[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkNameText))])]):_c('span',[_vm._v("\n    "+_vm._s(_vm.linkNameText)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af467e10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FootLinkNote.vue
// module id = 122
// module chunks = 1